function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Check-1{fill:#457446;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Check"
}, /*#__PURE__*/React.createElement("path", {
  className: "Check-1",
  d: "M30.71,5.09a4.1,4.1,0,0,0-5.66,0L11.88,18.26,6.83,13.21a4.1,4.1,0,0,0-5.66,0,4,4,0,0,0,0,5.66l7.88,7.88a4,4,0,0,0,5.65,0l16-16a4,4,0,0,0,0-5.66ZM29.29,9.34l-16,16a2,2,0,0,1-2.83,0L2.58,17.46A2,2,0,0,1,4,14a2,2,0,0,1,1.41.59l5.76,5.75a1,1,0,0,0,1.41,0L26.46,6.51a2,2,0,0,1,2.83,0,2,2,0,0,1,.59,1.41A2,2,0,0,1,29.29,9.34Z",
  transform: "translate(0 -3.96)"
}));

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Check_1",
    "data-name": "Check 1",
    viewBox: "0 0 31.88 23.96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Check.44ac59bc.svg";
export { ForwardRef as ReactComponent };